module.exports = __webpack_public_path__ + "static/media/attr_health_checkup.6b1885b0.svg";